<template>
    <app-content>
        <form action="#">
            <div class="inner">
                <p class="buttons">
                    <app-button-delete @click="deleteItem" v-if="!newItem"/>
                </p>
                <app-content-title v-if="!newItem && !pending && !deleting"
                                   :title="item.languageNames[currentLanguageId]"/>
                <app-content-title v-if="newItem" :title="translations.newLanguage"/>
            </div>
            <app-tabs
                    :colsTabs="columnTabs"
                    :shouldLoadFirstTab="newItem"
                    :loadTab="params.tab"
                    @appTabChanged="onAppTabChanged"
            >
                <div :title="translations.information">

                    <app-settings @submit="onFormSubmit" :disabled="pending">
                        <app-settings-content>
                            <app-settings-desc :title="translations.basicInfo">
                                <p>
                                    <translate>Založeno</translate>
                                    :<br/>
                                    <span v-html="formatDateAdvanced(item._created)"/>
                                </p>
                            </app-settings-desc>

                            <app-settings-options>

                                <app-settings-col class="field_left">
                                    <app-input
                                            :label="translations.isoCode"
                                            required
                                            :error="errors.items.find(el => el.field === 'isoCode')"
                                            v-model="formItem.isoCode"
                                            name="isoCode"
                                    />

                                    <app-checkbox
                                        name="deviceLanguage"
                                        :title="translations.deviceLanguage"
                                        :error="!!errors.first('deviceLanguage')"
                                        v-model="formItem.deviceLanguage"
                                    />
                                </app-settings-col>
                                <template v-if="!newItem && !deleting">
                                    <template v-for="(language, key) in languages">
                                        <app-settings-col
                                                :class="{ 'field_left': key%2 == 0, 'field_right': key%2 == 1 }"
                                                :key="key">
                                            <app-input
                                                    required
                                                    :label="translations.languageTitleText + ' ' + language.languageName"
                                                    :error="errors.items.find(el => el.field === 'languageNames' && el.inputField == language._id)"
                                                    v-model="formItem.languageNames[language._id]"
                                                    :name="`transObj-languageNames-${language._id}`"
                                            />
                                        </app-settings-col>
                                    </template>
                                </template>

                                <template v-else>
                                    <app-settings-col class="field_right">
                                        <app-input
                                                required
                                                :label="translations.languageNameInNewLanguage"
                                                :error="errors.items.find(el => el.field === 'languageNames' && el.inputField == 0)"
                                                :name="`transObj-languageNames-0`"
                                        />
                                    </app-settings-col>
                                    <template v-for="(language, key) in languages">
                                        <app-settings-col
                                                :class="{ 'field_left': key%2 == 0, 'field_right': key%2 == 1 }"
                                                :key="key">
                                            <app-input
                                                    required
                                                    :label="translations.languageTitleText + ' ' + language.languageName"
                                                    :error="errors.items.find(el => el.field === 'languageNames' && el.inputField == language._id)"
                                                    :name="`transObj-languageNames-${language._id}`"
                                            />
                                        </app-settings-col>
                                    </template>
                                </template>

                            </app-settings-options>
                        </app-settings-content>

                        <app-settings-content v-if="newItem">
                            <app-settings-desc :title="translations.otherLanguageNamesInNewLanguage"/>
                            <app-settings-options>
                                <template v-for="(language, key) in languages">
                                    <app-settings-col :class="{ 'field_left': key%2 == 0, 'field_right': key%2 == 1 }"
                                                      :key="key">
                                        <app-input
                                                required
                                                :label="language.languageName + ' ' + translations.inNewLanguageText"
                                                :error="errors.items.find(el => el.field === 'languagesNames' && el.inputField == language._id)"
                                                :name="`transObj-languagesNames-${language._id}`"
                                        />
                                    </app-settings-col>
                                </template>
                            </app-settings-options>
                        </app-settings-content>
                        <app-settings-content>
                            <app-settings-desc :title="translations.nameAndDescriptionOfGeneratedBroadcast"/>
                            <app-settings-options>
                                <app-settings-col class="field_left">
                                    <app-input
                                            :label="translations.name"
                                            required
                                            :error="errors.items.find(el => el.field === 'defaultBroadcastName')"
                                            name="defaultBroadcastName"
                                            v-model="formItem.defaultBroadcastName"
                                    />
                                </app-settings-col>
                                <app-settings-col>
                                    <app-settings-input
                                            :error="errors.items.find(el => el.field === 'defaultBroadcastDescription')"
                                            :label="translations.description"
                                    >
                                        <app-textarea
                                                name="defaultBroadcastDescription"
                                                v-model="formItem.defaultBroadcastDescription"
                                        />
                                    </app-settings-input>
                                </app-settings-col>
                            </app-settings-options>
                        </app-settings-content>

                        <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'languages' }">
                            <app-content-save-button :disabled="pending" @click="disallowBack"/>
                        </app-settings-buttons>
                    </app-settings>
                </div>
                <div
                        :title="translations.synonyms + ' (' + (item.synonyms ? item.synonyms.length : 0) + ')'"
                        :data-disabled-title="translations.synonymsSaveLanguageFirst"
                        :data-disabled="!item || !item._id || !item.synonyms"
                >
                    <synonyms
                            :item="item"
                    />
                </div>
            </app-tabs>
        </form>
    </app-content>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import getLanguagesMixin from 'mixins/getLanguagesMixin'
import Synonyms from '../../components/Languages/Synonyms'
import { getCommonFormSubmit } from 'utils/form'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'Language'
})

export default {
  name: 'language-item',
  mixins: [getLanguagesMixin, formatDateMixin, itemDetailMixin, appTitleMixin()],
  components: {
    Synonyms
  },
  data() {
    return {
      columnTabs: [
        0,
        1
      ]
    }
  },
  created() {
    this.fetchLanguages()
    this.params.tab = 0
  },
  methods: {
    async onFormSubmit(e) {
      this.errors.clear()

      this.formErrors = await this.runValidation()
      if (this.formErrors.items.length > 0) {
        this.appShowErrors(this.formErrors.items.map(v => v.msg))
        return
      }

      const commonFormSubmit = getCommonFormSubmit('Language')
      const response = await
      commonFormSubmit(this, e, { synonyms: (this.item.synonyms) ? this.item.synonyms : [] })
        .catch(err => err.response)

      this.handleResponseIfError(response)

      if (!this.backAllowed && response.status === 201) {
        this.goToDetail(response.data.data._id)
      }
    },
    async runValidation() {
      await this.errors.clear()
      await this.$validator.validateAll()
      return this.errors
    }
  },
  computed: {
    ...mapState({
      language: state => state.languages.language
    }),
    translations() {
      return {
        deviceLanguage: this.$gettext('Jazyk zařízení'),
        languageTitleText: this.$gettext('Název v jazyku '),
        inNewLanguageText: this.$gettext('v novém jazyce'),
        newLanguage: this.$gettext('Nový jazyk'),
        basicInfo: this.$gettext('Základní údaje'),
        isoCode: this.$gettext('ISO 639-3'),
        languageNameInNewLanguage: this.$gettext('Název jazyku v novém jazyku'),
        otherLanguageNamesInNewLanguage: this.$gettext('Názvy ostatních jazyků v novém jazyku'),
        nameAndDescriptionOfGeneratedBroadcast: this.$gettext('Název a popis generovaného vysílání'),
        name: this.$gettext('Název'),
        description: this.$gettext('Popis *'),
        list: this.$gettext('Seznam'),
        synonyms: this.$gettext('Synonyma'),
        information: this.$gettext('Informace'),
        synonymsSaveLanguageFirst: this.$gettext('Synonyma (nutné uložit jayzk)')
      }
    },
    deleting() {
      if (this.formItem.languageNames) {
        return false
      } else {
        return true
      }
    },
    currentTitle() {
      const itemName = this.item.languageNames ? this.item.languageNames[this.currentLanguageId] : this.$gettext('Nový jazyk')
      return [
        { name: this.$gettext('Jazyky'), link: { name: 'languages' } },
        itemName
      ]
    }
  }
}
</script>
